var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('Snackbar'),_c('Confirm'),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }